import React, { Component } from 'react';

class Portfolio extends Component {
  render() {
    return (
      <section id="portfolio">
        <div className="row projects">
          <div className="twelve columns collapsed">
            <h1>Check Out My Projects</h1>
            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
            <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a href="https://github.com/U-c0de/Rescue-Women-Fight-Back" className="image fit thumb" target="_blank" rel="noopener noreferrer"><img src="images/thumbs/06.gif" alt="Rescue" /></a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>Women Emergency Alert Website</h3>
                      <h6> Django-Python, SQlite, JavaScript, MapAPI</h6>
                      <br></br>
                      <p>A Women Security responsive website from which alert e-messages can be sent to saved contacts in emergency situations.</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                        <li><a href="https://github.com/U-c0de/Rescue-Women-Fight-Back" className="button project-button brands" target="_blank" rel="noopener noreferrer"><i className="fa fa-github icon"></i>View Source</a></li>
                      </div>
                      <div className="languages">
                        <i className=""></i>
                        <i className=""></i>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a href="https://github.com/U-c0de/BabbleBee" className="image fit thumb" target="_blank" rel="noopener noreferrer"><img src="images/thumbs/89.gif" alt="Using-Bootstrap" /></a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>BabbleBee</h3>
                      <h6> ReactJs, NodeJs, ExpressJs, MongoDB </h6>
                      <br></br>
                      <p>Real time Chat Application uisng MERN and Socket.io with profile avatar settings and chat interface with respective connections.	</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                        
                        <li><a href="https://github.com/U-c0de/BabbleBee" className="button project-button brands" target="_blank" rel="noopener noreferrer"><i className="fa fa-github icon"></i>View Source</a></li>
                      </div>
                      <div className="languages">
                        <i className=""></i>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
            <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a href="https://github.com/U-c0de/Press-Services-Website" className="image fit thumb" target="_blank" rel="noopener noreferrer"><img src="images/thumbs/08.gif" alt="pic-some" /></a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>PressServices App</h3>
                      <h6> ReactJs, EmailJs, JavaScript</h6>
                      <br></br>
                      <p>A fully responsive portfolio website using React-App, emailjs ,React-component & Hooks of a printing press describing about the services it offers with sample work uploaded too.</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                      <li><a href="https://u-c0de.github.io/PressServices" className="button project-button" target="_blank" rel="noopener noreferrer">View Demo</a></li>                        
                      <li><a href="https://github.com/U-c0de/Press-Services-React-Website" className="button project-button brands" target="_blank" rel="noopener noreferrer"><i className="fa fa-github icon"></i>View Source</a></li>
                      </div>
                      <div className="languages">
                        <i className=""></i>
                        <i className=""></i>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
    
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a href="https://github.com/U-c0de/Email-Authentication-Registration" className="image fit thumb" target="_blank" rel="noopener noreferrer"><img src="images/thumbs/76.gif" alt="react-capstone" height="200"/></a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>Email Authentication Server</h3>
                      <h6> NodeJs, JavaScript</h6>
                      <br></br>
                      <p>A project to setup registration and email authentication of registered email to the respective website as the requirements.</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                        
                        <li><a href="https://github.com/U-c0de/Email-Authentication-Registration" className="button project-button brands" target="_blank" rel="noopener noreferrer"><i className="fa fa-github icon"></i>View Source</a></li>
                      </div>
                      <div className="languages">
                      <i className=""></i>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a href="https://github.com/U-c0de/WhatScore-LiveCricketUpdates" className="image fit thumb" target="_blank" rel="noopener noreferrer"><img src="images/thumbs/78.gif" alt="Using-Bootstrap" /></a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>LiveScore Feeds</h3>
                      <h6> Python-Flask, Cric API, JSON, Twilio</h6>
                      <br></br>
                      <p>WhatScore - A Mini project based on python libraries which gives Live cricket score updates score directly on WhatsApp Messenger.</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                        
                        <li><a href="https://github.com/U-c0de/WhatScore-LiveCricketUpdates" className="button project-button brands" target="_blank" rel="noopener noreferrer"><i className="fa fa-github icon"></i>View Source</a></li>
                      </div>
                      <div className="languages">
                        <i className=""></i>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
              <ul className="actions">
                <li className="wide-button"><a href="https://github.com/U-c0de" className="button portfolio-button" target="_blank" rel="noopener noreferrer">Full Portfolio</a></li>
              </ul>
            </div>
          </div>
        </div>
   </section>
    );
  }
}

export default Portfolio;
